import moment from "moment";
import React, { Component } from "react";
import Pagination from "react-js-pagination";
import Loader from "./Loader";
import { iHaveHRMSSubscription, RecruiterMessage, RecruiterMessageList } from "../../action/jobs";
import ModalWindow1 from "../Common/ModalWindow1";
import { SiGooglemeet } from 'react-icons/si/'
import queryString from 'query-string';
import nl2br from 'react-nl2br';
import NotHaveHRMS from './NotHaveHRMS'
import userlogo from '../../assets/images/user-logo.png'
import ReactReadMoreReadLess from "react-read-more-read-less";
import {
  applicationstatuslist,
  forwardCandidateMail,
  jobApplications,
  UpdateJobResponse,
  getInterviewStatus,
  SendMessage,
  sendcandidaterating,
  setInterviewStatus,
  addRemark
} from "../../action/jobs";
import { clearForm, getAuthHeader, getStorage, onChange, ToSeoUrl } from "../../utils";
import Shimmer from "../Common/Shimmer";
import FileSaver from "file-saver";
import constant from "../../constant";
import ModalWindow from "../Common/ModalWindow";
import Forward from "./forward";
import axios from 'axios'
import AddMeeting from './AddMeeting'
import CenterModel from "./CenterModel";
import Swal from "sweetalert2";
import Form from 'react-bootstrap/Form';
import { reScheduleZoomMeeting } from "../../action/jobs";
import { getParameterByName } from "../../utils";
import './../../assets/css/JoinInterview.css'
// import './../../assets/scss/meet.scss'
import { ToastContainer, toast } from 'react-toastify';
import { TiTick } from 'react-icons/ti';
import { AiOutlineClose } from 'react-icons/ai';
import { GrInProgress } from 'react-icons/gr';
import TableMeet from "./TableMeet";
import HaveHRMS from './HaveHRMS'
import { withRouter } from "react-router-dom";
// import { department, designation, employementType, reportingaManager, role, shift, workLocation } from "../../action/hrms";
import Remark from './Remark'
class JobApplicationList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: { name: 'message', value: "", error: "" },
      JOB_ID: "",
      recuiterDetail: getStorage(constant.keys.userDetails),
      FILTER_BY: {
        name: "FILTER_BY",
        value: props.FILTER_BY ? props.FILTER_BY : "ALL",
        options: ["ALL", "CLOSED", "OPEN", "ON HOLD"],
        error: "",
      },
      LIMIT: {
        name: "LIMIT",
        value: props.LIMIT ? props.LIMIT : 10,
        options: [10, 20, 40, 50],
        error: "",
      },
      PAGE: { name: "PAGE", value: props.PAGE ? props.PAGE : 1, error: "" },
      KEYWORD: {
        name: "KEYWORD",
        value: props.KEYWORD ? props.KEYWORD : "",
        error: "",
        isRequired: true,
      },
      COUNT: undefined,
      SELECTION_PROCESS: props.SELECTION_PROCESS ? props.SELECTION_PROCESS : "",
      COMMENT: { name: "COMMENT", value: "", error: "", isRequired: true },
      jobActiveNess: {
        OPEN: ["CLOSED", "ON HOLD"],
        CLOSED: ["OPEN", "ON HOLD"],
        ON_HOLD: ["CLOSED", "OPEN"],
      },
      ShowEmailHover: false,
      APPLICATION_LIST: [],
      SelectedCandidate: [],
      AppliedCount: undefined,
      InterviewCount: undefined,
      InProgressCount: undefined,
      ShortlistedCount: undefined,
      OfferesAndJoiningCount: undefined,
      showForwardModal: false,
      statuslist: [],
      showEmailMassageModal: false,
      createLink: false,
      addMeeting: false,
      recrtMeetingUrl: "",
      selectedCandidateId: "",
      interviewTypeId: undefined,
      interviewStatusList: undefined,
      updateMeeting: undefined,
      updateMeetingNumber: undefined,
      scid: [],
      showLoader: undefined,
      showYoudoesnothaveHRMSModal: false,
      showYouhaveHRMSModal: false,
      org_id: undefined,
      role: undefined,
      designation: undefined,
      workLocation: undefined,
      department: undefined,
      shift: undefined,
      reportingaManager: undefined,
      employementType: undefined,
      CANDIDATE_ID: undefined,
      messageList: undefined,
      showRemarkModal: false,
      APPLICATION_ID: null,
      REMARKS: [],
      showViewRemarkModal: false

    };
  }


  showEmailHover = (input) => {
    this.setState({ ShowEmailHover: input });
  };
  componentDidMount() {
    this.loadlist();
  }

  onPageChange = (input) => {
    onChange(this, this.state.PAGE.name, input);
    this.props.onPageChange(input);
  };

  onChange = (e) => {
    const { name, value } = e.target;
    onChange(this, name, value);
    if (name === "LIMIT") {
      this.props.onLimitChange(value);
    }
  };
  onselectCandidate = (CANDIDATE_ID) => {
    let array = this.state.SelectedCandidate;
    const index = array.indexOf(CANDIDATE_ID);
    if (index > -1) {
      // only splice array when item is found
      array.splice(index, 1); // 2nd parameter means remove one item only
    } else {
      const str = CANDIDATE_ID;
      array.push(str);
    }

    this.setState({ SelectedCandidate: array });
  };

  downloadResume = (input) => {
    const RESUME_FILE = input.RESUME_FILE;
    const CANDIDATE_ID = input.CANDIDATE_ID;
    FileSaver.saveAs(
      `${process.env.REACT_APP_BASE_URL}/candidate-resume/${CANDIDATE_ID}/${RESUME_FILE}`,
      RESUME_FILE
    );
  };

  downloadSelectedCandidateResume = () => {

    if (this.state.SelectedCandidate.length > 0) {
      this.state.SelectedCandidate.map((i) => {
        this.state.APPLICATION_LIST.map((j) => {
          if (i == j.CANDIDATE_ID) {
            const model = {
              RESUME_FILE: j.RESUME_FILE,
              CANDIDATE_ID: j.CANDIDATE_ID,
            };
            // this.downloadResume(model)
          }
        });
      });
    }

  };


  generateOfferLetter = (data, STATUS_ID) => {
    window.open(constant.component.LOI.url + `?candidate=${data?.CANDIDATE_NAME}&id=${data?.CANDIDATE_ID}&jid=${data?.JOB_ID}`, '_blank');
  }

  SendMessage = (e, item) => {

    if (e.keyCode == 13) {
      this.onAddMessage(item.CANDIDATE_ID)
    } else {
      this.onChange(e)
    }

  }
  changeSelectionProcess = (SELECTION_PROCESS) => {

    if (this.state.SELECTION_PROCESS !== SELECTION_PROCESS) {
      window.location.href =
        constant.component.JobApplicationList.url +
        `?job=${ToSeoUrl(this.props.JOB_TITLE)}&id=${this.props.JOB_ID}&l=${this.state.LIMIT.value
        }&p=${1}&s=${SELECTION_PROCESS}`;
    }

  };
  onSelectAllCandidate = () => {
    if (
      this.state.SelectedCandidate.length !== this.state.APPLICATION_LIST.length
    ) {
      let array = this.state.APPLICATION_LIST.map((i) => {
        return i.CANDIDATE_ID;
      });
      this.setState({ SelectedCandidate: array });
    } else {
      this.setState({ SelectedCandidate: [] });
    }
  };



  onPageChange = (input) => {
    onChange(this, this.state.PAGE.name, input)
    this.props.onPageChange(input)
  }

  // onChange = (e) => {

  //   const { name, value } = e.target

  //   onChange(this, name, value)
  //   if (name === 'LIMIT') {
  //     this.props.onLimitChange(value)
  //   }
  // }


  onselectCandidate = (CANDIDATE_ID) => {

    let array = this.state.SelectedCandidate
    const index = array.indexOf(CANDIDATE_ID);
    if (index > -1) { // only splice array when item is found
      array.splice(index, 1); // 2nd parameter means remove one item only
    }
    else {
      const str = CANDIDATE_ID
      array.push(str)
    }

    this.setState({ SelectedCandidate: array })
  }



  downloadResume = (input) => {
    const RESUME_FILE = input.RESUME_FILE
    const CANDIDATE_ID = input.CANDIDATE_ID
    FileSaver.saveAs(
      `${process.env.REACT_APP_BASE_URL}/candidate-resume/${CANDIDATE_ID}/${RESUME_FILE}`,
      RESUME_FILE
    );

  }

  downloadSelectedCandidateResume = () => {
    if (this.state.SelectedCandidate.length > 0) {
      this.state.SelectedCandidate.map(i => {
        this.state.APPLICATION_LIST.map(j => {
          if (i == j.CANDIDATE_ID) {
            const model = {
              RESUME_FILE: j.RESUME_FILE,
              CANDIDATE_ID: j.CANDIDATE_ID
            }
            // this.downloadResume(model)
          }
        })
      })
    }
  }
  // loadhrmslists = (org_id) => {
  //   role(org_id).then(res => {
  //     if (res.status) {
  //       this.setState({ role: res.result })
  //     }
  //   })

  //   designation(org_id).then(res => {
  //     if (res.status) {
  //       this.setState({ designation: res.result })
  //     }
  //   })

  //   workLocation(org_id).then(res => {
  //     if (res.status) {
  //       this.setState({ workLocation: res.result })
  //     }
  //   })

  //   department(org_id).then(res => {
  //     if (res.status) {
  //       this.setState({ department: res.result })
  //     }
  //   })

  //   shift(org_id).then(res => {
  //     if (res.status) {
  //       this.setState({ shift: res.result })
  //     }
  //   })

  //   reportingaManager(org_id).then(res => {
  //     if (res.status) {
  //       this.setState({ reportingaManager: res.result })
  //     }
  //   })
  //   employementType(org_id).then(res => {
  //     if (res.status) {
  //       this.setState({ employementType: res.result })
  //     }
  //   })

  // }

  updateJobResponse = (data, STATUS_ID) => {
    if (STATUS_ID == 10) {
      this.generateOfferLetter(data, STATUS_ID)
      return true
    }
    if (STATUS_ID == 11) {
      const model = {
        STATUS_ID: STATUS_ID,
        CANDIDATE_ID: data.CANDIDATE_ID,
        JOB_ID: this.props.JOB_ID
      }
      UpdateJobResponse(model).then(res => {
        if (res.status) {
          this.loadlist()
        }
      }).catch(err => {
        console.log(err)
      })
      return true
    }
    // if ([7, 8, 9].includes(STATUS_ID)) {

    //   let interViewStatusName = ""
    //   switch (STATUS_ID) {
    //     case 7:
    //       interViewStatusName = "INTERVIEW ROUND 1"
    //       this.setState({ interViewStatusName })
    //       break;
    //     case 8:
    //       interViewStatusName = "INTERVIEW ROUND 2"
    //       this.setState({ interViewStatusName })
    //       break;
    //     case 9:
    //       interViewStatusName = "INTERVIEW ROUND 3"
    //       this.setState({ interViewStatusName })
    //       break;
    //   }

    //   let selectedCandidateId = [...this.state.scid, data.CANDIDATE_ID]
    //   this.setState({ scid: selectedCandidateId })
    //   this.setState({ interviewTypeId: STATUS_ID })
    //   this.setState({ showModel: true })
    //   this.setState({ createLink: true })
    // }

    if (data.APPLICATION_STATUS == STATUS_ID) {
      return false
    }

    const model = {
      STATUS_ID: STATUS_ID,
      CANDIDATE_ID: data.CANDIDATE_ID,
      JOB_ID: this.props.JOB_ID
    }

    UpdateJobResponse(model).then(res => {
      if (res.status) {
        this.loadlist()
      }

    }).catch(err => {
      console.log(err)
    })

  }

  changeSelectionProcess = (SELECTION_PROCESS) => {
    if (this.state.SELECTION_PROCESS !== SELECTION_PROCESS) {
      window.location.href = constant.component.JobApplicationList.url + `?job=${ToSeoUrl(this.props.JOB_TITLE)}&id=${this.props.JOB_ID}&l=${this.state.LIMIT.value}&p=${1}&s=${SELECTION_PROCESS}`
    }

  }
  onSelectAllCandidate = () => {
    if (this.state.SelectedCandidate.length !== this.state.APPLICATION_LIST.length) {
      let array = this.state.APPLICATION_LIST.map(i => {
        return i.CANDIDATE_ID
      })
      this.setState({ SelectedCandidate: array })
    }
    else {
      this.setState({ SelectedCandidate: [] })
    }
  }

  showForwardModal = () => {
    if (this.state.SelectedCandidate.length > 0) {
      this.setState({ showForwardModal: !this.state.showForwardModal })
    }
    else {
      Swal.fire({
        icon: "error",
        text: "Please Select Candidate To Send Message",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  }

  onForward = (model) => {
    model.CANDIDATE_ID = this.state.SelectedCandidate;
    forwardCandidateMail(model).then(res => {
      if (res.status) {
        this.setState({ showForwardModal: false })
        Swal.fire({
          icon: "success",
          text: res.result.message,
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
      else {
        Swal.fire({
          icon: "error",
          text: res.error,
          timer: 1500,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    })
  }

  showModel = (selectedCandidate) => {
    let selectedCandId = selectedCandidate.CANDIDATE_ID;
    let selectedJobId = selectedCandidate.APPLICATION_ID;
    this.setState({ selectedJobId: selectedJobId })
    this.setState({ addMeeting: !this.state.addMeeting })
    this.setState({ selectedCandidateId: selectedCandId })

  }

  scheduleMeeting = (model) => {
    const { interviewTypeId, selectedCandidateId, selectedJobId } = this.state
    console.log("interviewTypeId", interviewTypeId, "selectedCandidateId", selectedCandidateId)
    const { recuiterDetail } = this.state
    let startTime = parseInt(model.from * 60)
    let endTime = parseInt(model.to)
    let when = model.when

    let totalDurationInMinutes = startTime + endTime
    let date = model.startDate
    let topic = model.topic
    let hostEmail = constant.hostEmail
    // let hostName = recuiterDetail.EMAIL
    let email = constant.hostEmail

    const candidateDetail = {
      interviewTypeId, selectedCandidateId
    }

    const data = {
      totalDurationInMinutes, date, topic, hostEmail, candidateDetail, when, email, selectedJobId
    }

    const schMeeting = () => {

      if (totalDurationInMinutes || date || topic || hostEmail || candidateDetail || when || email) {

        console.log(data)
        this.setState({
          scid: this.state.scid.filter((i) => {
            return i != data.candidateDetail.selectedCandidateId
          })
        })

        return new Promise((resolve, reject) => {
          axios
            .post(`${process.env.REACT_APP_BASE_URL}/schedule-meeting`, data, getAuthHeader())
            .then((response) => {
              this.setState({ addMeeting: false })

              Promise.resolve({ message: " meeting scheduled succesfully " })

              getInterviewStatus().then((res) => {
                if (res.status) {
                  this.setState({ interviewStatusList: res.result })
                  this.setState({ showLoader: false })
                  toast.dismiss();
                  toast.success('Meeting scheduled ', {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                  Promise.resolve({ message: " meeting scheduled succesfully " })
                }

              }).catch(err => {
                toast.dismiss();
                Promise.reject({ message: " some error occured  " })
              })

            })
            .catch((err) => {
              toast.dismiss()
              Promise.reject({ message: " some error occured " })
            }

            );

        })
      }
    }

    let myPromise = schMeeting()

    toast.promise(
      myPromise,
      {
        pending: 'Please Wait... ',
        success: (data) => `scheduled meeting  `,
        error: (err) => `Some error occured  `,
      },
      {
        style: {
          minWidth: '250px',
        },
        success: {
          duration: 5000,
          icon: '🔥',
        },
      }
    );

  }
  saveFile = (model) => {
    const { DOC_FILE_NAME, CANDIDATE_ID } = model
    FileSaver.saveAs(
      `${process.env.REACT_APP_BASE_URL}/candidate-doc-file/${CANDIDATE_ID}/${DOC_FILE_NAME}`,
      DOC_FILE_NAME
    );
  }



  onAddMessage = (CANDIDATE_ID) => {
    const { message } = this.state
    const model = {
      MESSAGE: message.value,
      JOB_ID: this.props.JOB_ID,
      CANDIDATE_ID: CANDIDATE_ID
    }
    if (message.value.length > 0) {
      RecruiterMessage(model).then((res) => {
        if (res.status) {
          clearForm(this)
          RecruiterMessageList({ JOB_ID: this.props.JOB_ID, CANDIDATE_ID: CANDIDATE_ID }).then((res) => {
            if (res.status) {
              this.setState({ messageList: res.result.list })
            }
          })
        } else {
          alert(res.error)
        }
      })
    }


  }
  fetchConversation = (item) => {
    RecruiterMessageList({ JOB_ID: this.props.JOB_ID, CANDIDATE_ID: item.CANDIDATE_ID }).then((res) => {
      if (res.status) {
        this.setState({ messageList: res.result.list })
      }
    })
  }

  onSearch = (e) => {
    e.preventDefault();
    const qParam = queryString.parse(this.props?.location?.search)
    if (this.state.KEYWORD.value?.length > 0) {
      window.location.href = constant.component.JobApplicationList.url + `?job=${qParam?.job}&id=${qParam?.id}&l=${10}&p=${1}&s=all&k=${this.state.KEYWORD.value}`
    }
  }
  onAddRemark = (model) => {
    model.APPLICATION_ID = this.state.APPLICATION_ID;
    addRemark(model).then(res => {

      if (res.status) {
        Swal.fire({
          icon: "success",
          text: 'Remark Added Successfully',
          timer: 1500,
          showCancelButton: false,
          showConfirmButton: false,
        });
        setTimeout(this.setState({ showRemarkModal: false }), 1500)
        this.loadlist()
      }
      else {
        Swal.fire({
          icon: "error",
          text: res.error,
          timer: 1500,
          showCancelButton: false,
          showConfirmButton: false,
        });
        setTimeout(this.setState({ showRemarkModal: false }), 1500)

      }
    })
  }
  openAddRemarkModal = (APPLICATION_ID) => {
    this.setState({ APPLICATION_ID: APPLICATION_ID, showRemarkModal: true })
  }
  openViewRemarkModal = (LIST) => {
    this.setState({ REMARKS: LIST, showViewRemarkModal: true })
  }

  render() {
    const { messageList, showRemarkModal, showViewRemarkModal, REMARKS } = this.state
    const {
      ShowEmailHover, recuiterDetail, statuslist, showModel,
      org_id, role, designation, workLocation, employementType, department, shift, reportingaManager,
      APPLICATION_LIST, COUNT, LIMIT, PAGE, SelectedCandidate, showEmailMassageModal, SELECTION_PROCESS, CANDIDATE_ID,
      showForwardModal, AppliedCount, InterviewCount, InProgressCount, ShortlistedCount, OfferesAndJoiningCount
      , createLink, recrtMeetingUrl, interviewStatusList, scid, showYouhaveHRMSModal, showYoudoesnothaveHRMSModal, KEYWORD, message } = this.state
    const { ATS_ENABLED } = this.props;
    const qParam = queryString.parse(this.props?.location?.search)
    return (

      <React.Fragment>

        {/* {showYouhaveHRMSModal && (
          <ModalWindow1
            title={'HRMS Onboarding Form'}
          >
            <HaveHRMS
              org_id={org_id}
              role={role}
              designation={designation}
              JOB_ID={this.props.JOB_ID}
              reportingaManager={reportingaManager}
              department={department}
              shift={shift}
              CANDIDATE_ID={CANDIDATE_ID}
              employementType={employementType}
              location={workLocation}
            />

          </ModalWindow1>
        )} */}

        {/* {showYoudoesnothaveHRMSModal && (
          <ModalWindow
          >
            <NotHaveHRMS
              onToggle={() => { this.setState({ showYoudoesnothaveHRMSModal: false }) }}
            />
          </ModalWindow>
        )} */}


        {showEmailMassageModal && (
          <ModalWindow
            title="Send Message"
          >
            <Forward
              onSubmit={(model) => {
                this.onSendMessageToCandiate(model);
              }}
              hideTo={true}
              toggleModal={this.onMessageCancel}

            />
          </ModalWindow>
        )}
        {showForwardModal && (
          <ModalWindow
            title="Forward Candidate Profile"
          >
            <Forward
              onSubmit={(model) => {
                this.onForward(model);
              }}
              toggleModal={this.onCancel}

            />
          </ModalWindow>
        )}
        {
          showRemarkModal && (
            <ModalWindow
              title="Add Remark"
            >
              <Remark
                onSubmit={(model) => {
                  this.onAddRemark(model);
                }}
                toggleModal={() => this.setState({ showRemarkModal: false })}
              />
            </ModalWindow>
          )}

        {
          showViewRemarkModal && (
            <ModalWindow
              title="Remarks"
            >
              <React.Fragment>
                <div className="container">

                  <ol>
                    {
                      REMARKS?.map((item, index) => {
                        return (
                          <li>{item.REMARK}</li>
                        )
                      })}
                  </ol>
                  <button
                    className="btn btn-danger" style={{ display: "block", marginLeft: "auto" }}
                    onClick={() => this.setState({ showViewRemarkModal: false })}
                  >
                    CLOSE
                  </button>
                </div>

              </React.Fragment>
            </ModalWindow>
          )}

        <section className='pricing-area padding-top-70px padding-bottom-80px'>

          <div className='filterareabox'>
            <div className='filterareasearch'>
              <div className='container'>
                <div className='row'>
                  <div className='col-md-10'>
                    <h1 className='pt-2'>Requirement : {this.props.JOB_TITLE} <span></span></h1>
                  </div>
                  <div className='col-md-2 text-right'>
                    <h3>{COUNT} <span className='font-size-12'>Profile(s)</span></h3>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className='filterareamidsearch'>
              <div className='container'>
                <div className='row'>
                  <div className='col-md-8'>

                    <form className='rseachbox' onSubmit={this.onSearch}>
                      <p>Advanced&nbsp;Search&nbsp;&nbsp;</p>
                      <input
                        name={KEYWORD.name}
                        value={KEYWORD.value}
                        onChange={this.onChange}
                        type="text" />
                      <button type='submit'>Search <i class="fa fa-search" aria-hidden="true"></i></button>
                    </form>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="container">
              <div className="row">
                <div className="col-md-8">
                  <div className="paginationshowbox" style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <span>
                      Showing {LIMIT.value * PAGE.value - (LIMIT.value - 1)} to{" "}
                      {COUNT >= LIMIT.value * PAGE.value
                        ? LIMIT.value * PAGE.value
                        : LIMIT.value * PAGE.value -
                        (LIMIT.value * PAGE.value - COUNT)}{" "}
                      of {COUNT}
                    </span>
                    <ul>
                      <Pagination
                        activePage={PAGE.value}
                        itemsCountPerPage={LIMIT.value}
                        totalItemsCount={COUNT ? COUNT : 0}
                        pageRangeDisplayed={5}
                        onChange={this.onPageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                      />
                    </ul>
                  </div>
                </div>
                <div className="col-md-4">
                  {/* <div className="pagenumnerarea justify-content-end">
                    <p>Show</p>
                    <select
                      name={LIMIT.name}
                      value={LIMIT.value}
                      onChange={this.onChange}
                    >

                      {LIMIT.options.map((item) => {
                        return <option value={item}>{item}</option>;
                      })}
                    </select>
                    <p>Per Page</p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">

              {COUNT === undefined && (
                <div className="col-md-12">
                  <Shimmer />
                </div>
              )}
              {COUNT !== undefined && (
                <div className="col-md-12">
                  {/* <div className="emailforwadbox">
                    <ul>
                      <li>
                        <span
                          onClick={() => {
                            this.onSelectAllCandidate();
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={
                              this.state.SelectedCandidate.length ===
                              this.state.APPLICATION_LIST.length
                            }
                          />
                        </span>
                      </li>
                      <li className="emailmessage">
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            this.showEmailHover(!ShowEmailHover);
                          }}
                        >
                          <i class="fa fa-envelope" aria-hidden="true"></i>{" "}
                          Email
                        </a>
                        {ShowEmailHover && (
                          <ul
                            className="emailmessagehover"
                            onMouseLeave={() => {
                              this.showEmailHover(false);
                            }}
                          >
                            <span onClick={() => {
                              this.showEmailMassageModal()
                            }}> <li>Message</li></span>
                          </ul>
                        )}
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            this.showForwardModal();
                          }}
                        >
                          <i class="fa fa-share" aria-hidden="true"></i> Forward
                        </a>
                      </li>

                      {ATS_ENABLED && <li>
                        <a
                          target='_blank'
                          href={constant.component.onBoardCandidate.url + `?job=${qParam.job}&id=${qParam.id}`}
                        >
                          <i class="fa fa-user" aria-hidden="true"></i> OnBoard New Candidate
                        </a>
                      </li>}

                    </ul>
                  </div> */}

                  <div className="search-box-top">
                    <div className="search-box">
                      <form className="rseachbox" onSubmit={this.onSearch}>
                        <input
                          name={KEYWORD.name}
                          value={KEYWORD.value}
                          onChange={this.onChange}
                          type="text"
                          placeholder="Search  Candidate"
                        />
                        <button type="submit">
                          Search <i className="fa fa-search" aria-hidden="true" />
                        </button>
                      </form>
                    </div>


                    <div className="filte-and-email-bx">
                      <div className="email-Forward-bx">
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            this.showEmailMassageModal()
                          }}
                        >
                          <i class="fa fa-envelope" aria-hidden="true"></i>{" "}
                          Message
                        </a> </div>
                      <div className="email-Forward-bx">
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            this.showForwardModal();
                          }}
                        >
                          <i class="fa fa-share" aria-hidden="true"></i> Forward
                        </a>
                        {/* <a href="javascript:void(0)"><i className="fa fa-share" aria-hidden="true"></i> Email Forward</a> */}
                      </div>
                      {ATS_ENABLED && <div className="email-Forward-bx">
                        <a
                          target='_blank'
                          href={constant.component.onBoardCandidate.url + `?job=${qParam.job}&id=${qParam.id}`}
                        >
                          <i class="fa fa-user" aria-hidden="true"></i> OnBoard New Candidate
                        </a>
                      </div>}
                      <div className="limet-page-bx">
                        <div className="pagenumnerarea justify-content-end">
                          <p>Show</p>
                          <select
                            name={LIMIT.name}
                            value={LIMIT.value}
                            onChange={this.onChange}
                          >

                            {LIMIT.options.map((item) => {
                              return <option value={item}>{item}</option>;
                            })}
                          </select>
                          <p>Per Page</p>
                        </div>

                      </div>


                    </div>


                  </div>

                  <div className="top-tab-section">

                    <ul className="top-tab-list">
                      <li className={SELECTION_PROCESS === "all"
                        ? "active"
                        : ""}><a onClick={() => {
                          this.changeSelectionProcess("all");
                        }} >All</a></li>
                      <li className={SELECTION_PROCESS === "applied"
                        ? "active"
                        : ""}><a onClick={() => {
                          this.changeSelectionProcess("applied");
                        }}>Applied ({AppliedCount})</a></li>
                      <li className={SELECTION_PROCESS === "shortlisted"
                        ? "active"
                        : ""}><a onClick={() => {
                          this.changeSelectionProcess("shortlisted");
                        }}>Shortlisted ({ShortlistedCount})</a></li>
                      <li className={SELECTION_PROCESS === "interview"
                        ? "active"
                        : ""}><a onClick={() => {
                          this.changeSelectionProcess("interview");
                        }} >Interview ({InterviewCount})</a></li>
                      <li className={SELECTION_PROCESS === "offerandjoining"
                        ? "active"
                        : ""}><a onClick={() => {
                          this.changeSelectionProcess("offerandjoining");
                        }} >Offers & Joining ({OfferesAndJoiningCount}) </a></li>
                      <li className={SELECTION_PROCESS === "inprogress"
                        ? "active"
                        : ""}><a onClick={() => {
                          this.changeSelectionProcess("inprogress");
                        }} >In Process ({InProgressCount})</a></li>
                    </ul>
                  </div>
                  {
                    APPLICATION_LIST.length > 0 ? APPLICATION_LIST.map((item, index) => {
                      return (
                        <div className="lob-list-item jm-job-layout-2">

                          <div className="jm-latest-job-item-3 mb-30">
                            <div className="jm-latest-job-item-top-3">
                              <div className="jm-latest-job-item-top-wrap-3">
                                <div className="prof-info-bx">
                                  <div className="jm-latest-job-item-logo-3 y_img">
                                    <a >
                                      <img src={item.PROFILE_IMAGE ? `${process.env.REACT_APP_BASE_URL}/candidate/pic/${item.CANDIDATE_ID}/${item.PROFILE_IMAGE}` : userlogo} alt="" />
                                    </a>
                                  </div>
                                  <div className="jm-latest-job-item-info-3">
                                    <h3 className="jm-latest-job-item-info-title-3">

                                      <div>
                                        <span
                                          onClick={() => {
                                            this.onselectCandidate(item.CANDIDATE_ID);
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={SelectedCandidate.includes(
                                              item.CANDIDATE_ID
                                            )}
                                          />
                                        </span>
                                        <span>&nbsp;{item.CANDIDATE_NAME}</span>
                                        <span
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => this.openAddRemarkModal(item.APPLICATION_ID)}>&nbsp;&nbsp;<i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;Add Remark</span>
                                        {item.REMARK.length > 0 && <span
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => this.openViewRemarkModal(item.REMARK)}>&nbsp;&nbsp;<i class="fa fa-eye" aria-hidden="true"></i>&nbsp;View Remark</span>}
                                      </div>
                                    </h3>
                                    <p className="jm-latest-job-item-info-subtitle-3" >
                                      {item.PROFILE_SUMMARY != null
                                        ? <ReactReadMoreReadLess
                                          charLimit={250}
                                          readMoreText={"Read more"}
                                          readLessText={"Read less"}
                                        >
                                          {(item.PROFILE_SUMMARY)}
                                        </ReactReadMoreReadLess>

                                        : "Not Available"
                                      }
                                    </p>

                                  </div>
                                </div>
                                <div className="other-info-box first">
                                  <div className="key-info key-info-first">
                                    <h5>Key info:</h5>

                                  </div>
                                  <div className="jm-latest-job-meta-wrapper key-info-second">
                                    <ul className="list-job-info">
                                      <li><span><i className="la la-map-marker"></i> Current Location:</span> {item.CURRENT_LOCATION}</li>
                                      <li><span><i className="la la-briefcase"></i> Exp:</span> {item.TOTAL_EXP_YEAR}{" "}
                                        Year(s) {item.TOTAL_EXP_MONTH} Month(s) | CTC:
                                        Rs {item.CTC} Lakhs</li>
                                      <li><span><i className="la la-industry"></i> Industry:</span> {item.INDUSTRY}</li>
                                      <li><span><i className="la la-industry"></i> Functional Area:</span> {item.FUNCTIONAL_AREA}</li>
                                      <li><span><i className="la la-graduation-cap"></i>  Education:</span>  {item.EDUCATION}</li>
                                      <li><span><i className="la la-graduation-cap"></i>  Current Designation:</span>  {item.CURRENT_DESIGNATION && item.CURRENT_DESIGNATION.length > 0 ? item.CURRENT_DESIGNATION : 'Not Available'}</li>
                                      <li><span><i className="la la-map-marker"></i>  Pref Location:</span>  {item.prefferedLocation.length > 0
                                        ? item.prefferedLocation.map((i, key) => {
                                          if (
                                            key ==
                                            item.prefferedLocation.length - 1
                                          ) {
                                            return i.CITY;
                                          } else {
                                            return i.CITY + ",";
                                          }
                                        })
                                        : "Not Available"}</li>
                                      {item.NOTICE_PERIOD && <li><span><i className="la la-graduation-cap"></i>  Notice Period:</span>  {item.NOTICE_PERIOD}</li>}

                                    </ul>
                                  </div>
                                </div>
                                <div className="other-info-box second">
                                  <div className="key-info key-info1">
                                    <h5>Key skills:</h5>

                                  </div>
                                  <div className="jm-latest-job-meta-wrapper">
                                    {item.SKILL.length > 0
                                      ? item.SKILL.map((i, key) => {
                                        return <a>{i.SKILL}</a>;
                                        // if (key == item.SKILL.length - 1) {
                                        //   return <a>i.SKILL</a>;
                                        // } else {
                                        //   return i.SKILL + ",";
                                        // }
                                      })
                                      : <b> Not Available</b>}
                                  </div>
                                </div>
                              </div>
                              <div className="jm-latest-job-item-btn-3">
                                <a className="applied-date jm-theme-btn">Applied On {moment(item.CREATED_ON).format("DD MMM YYYY")}{" "}</a>
                                <a
                                  className="jm-theme-btn jm-sendmail-btn"

                                >
                                  {item.APPLICATION_STATUS_NAME}
                                </a>
                                {<a className="jm-theme-btn jm-resume-down-btn"
                                  onClick={() => {
                                    this.downloadResume(item);
                                  }}
                                >
                                  <i className="fa fa-download"></i>  View Resume
                                </a>

                                }
                                {item.DOCS_LINK && <a
                                  onClick={() => { this.saveFile({ DOC_FILE_NAME: item.DOCS_LINK, CANDIDATE_ID: item.CANDIDATE_ID }) }}
                                  className="jm-theme-btn jm-resume-down-btn"
                                >
                                  <i className="fa fa-file-text-o"></i>  Documents
                                </a>
                                }
                                <div>
                                  <span onMouseOver={() => { this.setTemporaryRating(item.CANDIDATE_ID, 1) }} onMouseLeave={() => { this.unsetTemporaryRating(item.CANDIDATE_ID) }} onClick={() => { this.sendCandidateRating(item.CANDIDATE_ID, 1) }}> <i class="fa fa-star" aria-hidden="true" style={item.temporaryrating != null ? { color: '#ffc300' } : (item.rating >= 0) ? { color: '#ffc300' } : {}} ></i></span>
                                  <span onMouseOver={() => { this.setTemporaryRating(item.CANDIDATE_ID, 2) }} onMouseLeave={() => { this.unsetTemporaryRating(item.CANDIDATE_ID) }} onClick={() => { this.sendCandidateRating(item.CANDIDATE_ID, 2) }}> <i class="fa fa-star" aria-hidden="true" style={item.temporaryrating != null && item.temporaryrating >= 2 ? { color: '#ffc300' } : (item.rating >= 2) ? { color: '#ffc300' } : {}}></i> </span>
                                  <span onMouseOver={() => { this.setTemporaryRating(item.CANDIDATE_ID, 3) }} onMouseLeave={() => { this.unsetTemporaryRating(item.CANDIDATE_ID) }} onClick={() => { this.sendCandidateRating(item.CANDIDATE_ID, 3) }}> <i class="fa fa-star" aria-hidden="true" style={item.temporaryrating != null && item.temporaryrating >= 3 ? { color: '#ffc300' } : (item.rating >= 3) ? { color: '#ffc300' } : {}}></i> </span>
                                  <span onMouseOver={() => { this.setTemporaryRating(item.CANDIDATE_ID, 4) }} onMouseLeave={() => { this.unsetTemporaryRating(item.CANDIDATE_ID) }} onClick={() => { this.sendCandidateRating(item.CANDIDATE_ID, 4) }}> <i class="fa fa-star" aria-hidden="true" style={item.temporaryrating != null && item.temporaryrating >= 4 ? { color: '#ffc300' } : (item.rating >= 4) ? { color: '#ffc300' } : {}}></i> </span>
                                  <span onMouseOver={() => { this.setTemporaryRating(item.CANDIDATE_ID, 5) }} onMouseLeave={() => { this.unsetTemporaryRating(item.CANDIDATE_ID) }} onClick={() => { this.sendCandidateRating(item.CANDIDATE_ID, 5) }}> <i class="fa fa-star" aria-hidden="true" style={item.temporaryrating != null && item.temporaryrating >= 5 ? { color: '#ffc300' } : (item.rating >= 5) ? { color: '#ffc300' } : {}}></i> </span>

                                </div>

                                <div className="applymatchin-box">
                                  <a
                                    href="javascript:void(0)"
                                    className="applymatchin-btn dropdown-toggle"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    Applied - Matching
                                  </a>

                                  <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                  >

                                    {statuslist.map((i) => {
                                      return (
                                        <a
                                          class="dropdown-item"
                                          onClick={() => {
                                            this.updateJobResponse(
                                              item,
                                              i.STATUS_ID
                                            );
                                          }}
                                          href="javascript:void(0)"
                                        >
                                          {i.STATUS_NAME}
                                        </a>
                                      );
                                    })}

                                  </div>
                                  <a
                                    href="javascript:void(0)"
                                    onClick={() => {
                                      this.updateJobResponse(item, 5);
                                    }}
                                    className="reject-btn"
                                  >
                                    {item.APPLICATION_STATUS == 5
                                      ? "Rejected"
                                      : "Reject"}
                                  </a>
                                </div>
                                {/* <a
                                className="jm-theme-btn jm-resume-share-btn"
                                
                              >
                                <i className="fa fa-share-alt"></i> Share Resume
                              </a> */}
                              </div>
                            </div>

                          </div>



                        </div>)
                    }) : <div className="lob-list-item jm-job-layout-2" style={{ textAlign: 'center', fontSize: '15px' }}>
                      <div className="jm-latest-job-item-3 mb-30">
                        <div className="jm-latest-job-item-top-3">
                          <div className="jm-latest-job-item-top-wrap-3">
                            No Application received.
                            <a className="pr-1" target='_blank' href={constant.component.editJob.url + "?job=" + ToSeoUrl(qParam.job) + "&i=" + qParam.id} > Click here</a>
                            to update job to increase the responses.
                          </div > </div > </div > </div>}
                </div >
              )
              }
            </div>
          </div >

          {this.state.addMeeting ? <CenterModel onClick={this.scheduleMeeting} IR_STATUS={this.state.interViewStatusName} /> : ""}
          {this.state.updateMeeting ? <CenterModel onUpdate={this.reScheduleMeeting} update={1} /> : ""}
          {this.state.showLoader && <Loader />}

          <ToastContainer
            position="top-right"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          {/* Same as */}
          <ToastContainer />
        </section >

      </React.Fragment >
    );
  }



  loadlist = () => {

    const { LIMIT, PAGE, KEYWORD, SELECTION_PROCESS } = this.state;

    jobApplications({
      page: PAGE.value,
      limit: LIMIT.value,
      keyword: KEYWORD.value,
      JOB_ID: this.props.JOB_ID,
      SELECTION_PROCESS: SELECTION_PROCESS,
    }).then((res) => {
      if (res.status) {
        this.setState({
          APPLICATION_LIST: res.result.list,
          COUNT: res.result.count,
          AppliedCount: res.result.AppliedCount,
          InterviewCount: res.result.InterviewCount,
          InProgressCount: res.result.InProgressCount,
          ShortlistedCount: res.result.ShortlistedCount,
          OfferesAndJoiningCount: res.result.OfferesAndJoiningCount,
        });
      } else {
        Swal.fire({
          icon: 'error',
          text: res.error,
          timer: 1500,
          showCancelButton: false,
          showConfirmButton: false
        })
        console.log(res.error);
      }
    })
      .catch((err) => {
        console.log(err);
      });

    applicationstatuslist().then((res) => {

      if (res.status) {
        this.setState({ statuslist: res.result });
      }

    });

    getInterviewStatus().then((res) => {

      if (res.status) {
        this.setState({ interviewStatusList: res.result })
      }

    }).catch(err => {
      console.log("err ");
    })


  };

  onForward = (model) => {
    model.CANDIDATE_ID = this.state.SelectedCandidate

    forwardCandidateMail(model).then((res) => {
      if (res.status) {
        this.setState({ showForwardModal: false })
        Swal.fire({
          icon: "success",
          text: "Mail forward successfully",
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    })
      .catch((err) => {
        console.log(err);
      });
  };
  onMessageCancel = () => {
    this.setState({ showEmailMassageModal: false });
  };
  onCancel = () => {
    this.setState({ showForwardModal: false });
  };

  showEmailMassageModal = () => {

    if (this.state.SelectedCandidate.length > 0) {
      this.setState({ showEmailMassageModal: true })
    }

    else {
      Swal.fire({
        icon: "error",
        text: "Please Select Candidate To Send Message",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  }

  onSendMessageToCandiate = (model) => {

    model.CANDIDATE_ID = this.state.SelectedCandidate

    SendMessage(model).then((res) => {
      if (res.status) {
        this.setState({ showEmailMassageModal: false })

      }
    })
      .catch((err) => {
        console.log(err);
      });
  }

  setTemporaryRating = (CANDIDATE_ID, RATING) => {
    const LIST = this.state.APPLICATION_LIST.map(i => {
      if (i.CANDIDATE_ID == CANDIDATE_ID) {
        i.temporaryrating = RATING
      }
      return i
    })
    this.setState({ APPLICATION_LIST: LIST })
  }

  unsetTemporaryRating = (CANDIDATE_ID) => {
    const LIST = this.state.APPLICATION_LIST.map(i => {
      if (i.CANDIDATE_ID == CANDIDATE_ID) {
        i.temporaryrating = null
      }
      return i
    })
    this.setState({ APPLICATION_LIST: LIST })
  }

  sendCandidateRating = (CANDIDATE_ID, RATING) => {
    sendcandidaterating({ CANDIDATE_ID: CANDIDATE_ID, RATING: RATING }).then(res => {
      if (res.status) {
        this.loadlist()
      }
    })

  }



  reSchedule = (hostInterviewLink, interviewUpdateId) => {
    const { updateMeeting } = this.state
    const query = new URLSearchParams(hostInterviewLink.toString());
    let meetingNumber = getParameterByName('mnm', hostInterviewLink);
    this.setState({ updateMeetingNumber: meetingNumber })
    this.setState({ interviewUpdateId: interviewUpdateId })
    this.setState({ updateMeeting: !updateMeeting })

  }



  reScheduleMeeting = (model) => {
    const { updateMeetingNumber, interviewUpdateId } = this.state
    let startTime = parseInt(model.from * 60)
    let endTime = parseInt(model.to)
    let when = parseInt(model.when)
    let totalDurationInMinutes = startTime + endTime
    let date = model.startDate
    let topic = model.topic
    let hostEmail = constant.hostEmail
    // let hostName = recuiterDetail.EMAIL
    let email = constant.hostEmail

    const data = { totalDurationInMinutes, date, topic, hostEmail, when, updateMeetingNumber, interviewUpdateId }

    reScheduleZoomMeeting(data).then(res => {

    }).catch(err => {
    })

  }


  changeInterviewStatus = (e, index) => {


    let interviewStatus = e.target.value
    console.log("interviewStatus", interviewStatus);

    const model = {
      interviewStatus: interviewStatus,
      index: index
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-outline-success btn-sm mx-3 px-sm-3',
        cancelButton: 'btn btn-outline-danger btn-sm mx-3 '
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons.fire({
      title: 'Are you sure?',
      text: ` you want to ${model.interviewStatus == constant.status.QUALIFIED ? "qualify" : model.interviewStatus == constant.status.REJECTED ? "reject" : ""} the Candidate `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Yes`,
      cancelButtonText: 'cancel',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {

        setInterviewStatus(model).then(res => {

          getInterviewStatus().then((res) => {
            if (res.status) {
              this.setState({ interviewStatusList: res.result })
            }

          }).catch(err => {
            console.log("err ", err);
          })

        }).catch(err => {
          console.log(err)
        })

      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {

        swalWithBootstrapButtons.fire(
          'Dismissed'
        )
      }
    })


  }


}
export default withRouter(JobApplicationList)



